// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import {UitkHeading, UitkParagraph, UitkText} from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkList } from 'uitk-react-list';

export interface PzFormInfoDialogProps {
  dialogId: string;
  infoEntry: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
}

export const PzFormInfoDialog: React.FunctionComponent<PzFormInfoDialogProps> = ({
  dialogId,
  infoEntry,
  l10n,
  routeStore,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  let dialogHeading = 'You are joining Partnerize';
  let dialogContent = (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        {dialogHeading}
      </UitkHeading>
    </UitkDialogContent>
  );

  if (infoEntry === 'eligibility') {
    dialogHeading = 'pz.signup.info.dialog.eligibility.title';

    dialogContent = (
      <UitkDialogContent>
        <UitkHeading tag="h3" size={5}>
          <LocalizedText message={dialogHeading} />
        </UitkHeading>
        <UitkSpacing margin={{ blockstart: 'six' }}>
          <div>
            <UitkParagraph size={1}>
              <LocalizedText message="pz.signup.info.dialog.eligibility.paragraph1" />
            </UitkParagraph>
          </div>
        </UitkSpacing>
      </UitkDialogContent>
    );
  }

  if (infoEntry === 'username') {
    const pzUserRulesAlphanumeric = l10n.formatText('pz.username.rules.item1');
    const pzUserRulesMustUnique = l10n.formatText('pz.username.rules.item2');
    const pzUserRulesLengthMin = l10n.formatText('pz.username.rules.item3');
    const pzUserRulesLengthMax = l10n.formatText('pz.username.rules.item4');

    dialogHeading = 'username';

    dialogContent = (
      <UitkDialogContent>
        <UitkHeading tag="h3" size={5}>
          <LocalizedText message={dialogHeading} />
        </UitkHeading>
        <UitkSpacing margin={{ blockstart: 'six' }}>
          <div>
            <UitkList
              data={[pzUserRulesMustUnique, pzUserRulesAlphanumeric, pzUserRulesLengthMin, pzUserRulesLengthMax]}
            />
          </div>
        </UitkSpacing>
      </UitkDialogContent>
    );
  }

  if (infoEntry === 'password') {
    const pzPasswordRulesUppercase = l10n.formatText('pz.password.rules.item1');
    const pzPasswordRulesLowercase = l10n.formatText('pz.password.rules.item2');
    const pzPasswordRulesValidLength = l10n.formatText('pz.password.rules.item3');
    const pzPasswordRulesHasSpecialChar = l10n.formatText('pz.password.rules.item4');
    const pzPasswordRulesHasNumber = l10n.formatText('pz.password.rules.item5');

    dialogHeading = 'password';

    dialogContent = (
      <UitkDialogContent>
        <UitkHeading tag="h3" size={5}>
          <LocalizedText message={dialogHeading} />
        </UitkHeading>
        <UitkSpacing margin={{ blockstart: 'six' }}>
          <div>
            <UitkList
              data={[
                pzPasswordRulesUppercase,
                pzPasswordRulesLowercase,
                pzPasswordRulesValidLength,
                pzPasswordRulesHasSpecialChar,
                pzPasswordRulesHasNumber,
              ]}
            />
          </div>
        </UitkSpacing>
      </UitkDialogContent>
    );
  }

  if(infoEntry === 'accountName') {
    dialogHeading = 'Account Name';
    dialogContent = (
      <UitkDialogContent>
        <UitkHeading tag="h3" size={5}>
          <LocalizedText message={dialogHeading} />
        </UitkHeading>
        <UitkText>{l10n.formatText('pz.signup.form.fields.account_name.dialog_text.name_by_which_your_acc_will_be_identified')}</UitkText>
        <UitkSpacing margin={{ blockstart: 'six' }}>
          <div>
            <UitkText>{l10n.formatText('pz.signup.form.fields.account_name.dialog_text.account_name_rules')}</UitkText>
            <UitkSpacing margin={{ blockstart: 'two' }}>
              <div>
                <UitkList
                  data={[
                    l10n.formatText('pz.signup.form.fields.account_name.rules.account_name_cannot_contain_username'),
                    l10n.formatText('pz.signup.form.fields.account_name.rules.account_name_should_be_unique'),
                    l10n.formatText('pz.signup.form.fields.account_name.rules.account_name_can_only_contain_alphanumeric_chars'),
                    l10n.formatText('pz.signup.form.fields.account_name.rules.account_name_length_must_be_greater_than_2'),
                    l10n.formatText('pz.signup.form.fields.account_name.rules.account_name_length_must_not_be_greater_than_32'),
                  ]}
                />
              </div>
            </UitkSpacing>
          </div>
        </UitkSpacing>
      </UitkDialogContent>
    );
  }

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzInfo" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
